module.exports = __webpack_public_path__ + "static/media/blueWBlogo.f7d1b2fd.svg";